export enum SessionStorageKeys {
  DONTASKDELETE = "dontaskdelete",
}
